module.exports = __webpack_public_path__ + "f4bf23aeb91c6ca7f6be7ba2c6a3782f.png";